<template lang="pug">

.homer
  .homer-intro
    AppIcon(name="logoHomer")
    p.homer-intro-desc.u-mt-xs {{$t('intro')}}
    ValidationObserver(ref="obs")
      .homer-intro-form.u-mt-md(slot-scope="{ validate }")
        .grid.is-homer.is-tablet-6
          .column
            TextInput.is-white(
              type="text"
              rules="required"
              :label="$t('forms.name')"
              v-model="fullName"
            )
          .column
            TextInput.is-white(
              rules="required|email"
              type="email"
              :label="$t('forms.email')"
              v-model="email"
            )
        label.checkbox.is-inline
          input.checkbox-input(type="checkbox" v-model="lists" value="BUSINESS")
          | {{$t('business')}}
        label.checkbox.is-inline
          input.checkbox-input(type="checkbox" v-model="lists" value="DESIGN")
          | {{$t('design')}}
        label.checkbox.is-inline
          input.checkbox-input(type="checkbox" v-model="lists" value="CODE")
          | {{$t('code')}}
        label.checkbox.is-inline
          input.checkbox-input(type="checkbox" v-model="lists" value="TECHNOLOGY")
          | {{$t('technology')}}
        button.button-link.u-mt-xm(@click="validate().then(onSubmit)" v-load="isSubmitting") {{$t('subscribe')}}
    img.homer-intro-img(src='https://cdn.baianat.com/static/resources/homer/1.png', srcset='https://cdn.baianat.com/static/resources/homer/1.png 1x, https://cdn.baianat.com/static/resources/homer/1@2x.png 2x' :alt="$t('pageTitle')")



  .homer-quote
    h2 {{$t('quote')}}
    img.homer-quote-img(src='https://cdn.baianat.com/static/resources/homer/2.png', srcset='https://cdn.baianat.com/static/resources/homer/2.png 1x, https://cdn.baianat.com/static/resources/homer/2@2x.png 2x' :alt="$t('quote')")

  .u-mt-sm
    .grid
      .column.u-mb-sm(v-for="item,idx in $t('features')")
        h4 {{item.title}}
        p {{item.desc}}


  .u-mb-md

</template>
<style lang="stylus">
$clYellow = #f7df4a

div.app.is-homer
  overflow: hidden
  background: $clYellow

  .header
    color: $clWhite

    a:hover
      color: $clYellow

    &.is-scroll
      background: $clPrimary

      a
        color: $clWhite

        &:hover
          color: $clYellow

.homer
  &-intro
    margin-left: -($outerMargin)
    margin-right: -($outerMargin)
    padding: 300px $outerMargin unitRes(100, 180)
    background: $clPrimary
    position: relative
    color: $clWhite
    position: relative
    z-index: 2
    border-bottom-right-radius: 400px

    +mq($until: 'tablet')
      margin-left: -($outerMargin-sm)
      margin-right: -($outerMargin-sm)
      padding: 300px $outerMargin-sm unitRes(100, 180)

    &-img
      position: absolute
      right: 0
      top: 0
      z-index: -1
      max-width: 50%

    .icon-logoHomer
      width: unitRes(300, 700)
      height: unitRes(80, 180)

    &-desc
      font-size: unitRes(30, 60)
      max-width: 830px

    .button-link
      color: $clWhite
      background-image: linear-gradient(to right, $clWhite 0%, $clWhite 100%)

      &:hover
        color: $clYellow
        background-image: linear-gradient(to right, $clYellow 0%, $clYellow 100%)

    &-form
      max-width: 1000px

      .input
        background: none
        border-color: $clWhite
        color: $clWhite

        &:focus
          border-color: $clBlack

      .checkbox-input, .radio-input
        border-color: $clWhite

        &:checked
          background: $clWhite

        &:after
          border-color: $clBlack

      .grid.is-homer
        margin-left: -10px
        margin-right: -10px

        .column
          padding-left: 10px
          padding-right: 10px

  &-quote
    position: relative
    z-index: 2
    padding: unitRes(100, 200) 0

    img
      position: absolute
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)
      z-index: -1
      max-width: 60%

html[lang^='ar']
  .homer-intro-img
    right: auto
    left: 0
    transform: scaleX(-1)
    filter: FlipH

  .homer-intro
    border-bottom-left-radius: 400px
    border-bottom-right-radius: 0
</style>

<script>
import { mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate/dist/vee-validate.minimal';
import TextInput from '~/components/inputs/TextInput';
import { Subscribe } from '~/graphql/Subscribe.gql';
import { load } from '~/directives';

export default {
  scrollToTop: true,
  meta: {
    theme: 'is-homer is-fixedHeader',
    logoText: '__NONE__'
  },
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },

  components: {
    TextInput,
    ValidationObserver
  },
  directives: { load },
  data: () => ({
    isSubmitting: false,
    fullName: '',
    email: '',
    lists: ['NEWS']
  }),
  methods: {
    ...mapActions({
      success: 'alert/success',
      error: 'alert/error'
    }),
    async onSubmit() {
      try {
        this.isSubmitting = true;
        await this.$api.mutate({
          mutation: Subscribe,
          variables: {
            input: {
              fullName: this.fullName,
              email: this.email,
              lists: this.lists,
              context: {
                pageUrl: window.location.href
              }
            }
          }
        });

        this.success(this.$t('success'));
        this.email = '';
        this.fullName = '';
        this.lists = ['NEWS'];
        this.$refs.obs.reset();
      } catch (err) {
        this.error(err.message);
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<i18n>
{
  "en": {
    "success": "We sent an email your way, please confirm your subscription!",
    "pageTitle":"Homer",
    "pageDesc":"Have a weekly bird’s eye view with the latest through Homer newsletter in business, design, code and technology.",
    "intro":"A weekly bird’s eye view on your fields of interest.",
    "business":"Business",
    "design":"Design",
    "code":"Code",
    "technology":"Technology",
    "subscribe":"Subscribe",
    "quote":"Roaming the internet to keep you in the scene. With the latest news, thoughts, tools and game changing tips.",
    "features":{
      "1":{
        "title":"Engaging Materials",
        "desc":"Manually picking useful and relevant updates from trusted sources."
      },
      "2":{
        "title":"Beautifully designed",
        "desc":"Using a clean design so you can have an enjoying reading experience."
      },
      "3":{
        "title":"Diversified content",
        "desc":"Articles, guides, tools, videos and everything that you need to boost your performance."
      }
    }
  },
  "ar": {
    "success": "اضغط على الرابط الذي تم ارساله لتصلك رسائل هومر الاسبوعية",
    "pageTitle":"هومر",
    "pageDesc":"احصل على التحديثات المختارة يدويًا مباشرة إلى صندوق بريدك الوارد في مجالك المفضل عبر النشرة الأسبوعية من هومر ",
    "intro":"اختار التحديثات المفيدة وذات الصلة بمجالك من أكثر المصادر الموثوق بها.",
    "business":"إدارة الأعمال",
    "design":"التصميم",
    "code":"البرمجة",
    "technology":"التكنولوجيا",
    "subscribe":"اشترك",
    "quote":"نتفقَّد الإنترنت بأكمله لإبقائك في المشهد،مع أحدث الأخبار والأفكار والأدوات والنصائح.",
    "features":{
      "1":{
        "title":"تفاعل لتعرف أكثر. ",
        "desc":"اختار يدوياً التحديثات المفيدة والمُتعلقة بمجال عملك  من المصادر الأكثر ثقةً."
      },
      "2":{
        "title":"مصممة جيداً لراحتك.",
        "desc":"استمتع بتجربة قراءة ممتعة من خلال تصميمات مميزة ومريحة للعين."
      },
      "3":{
        "title":"محتوى متنوع.",
        "desc":"ستجد المقالات والأدلة والأدوات ومقاطع الفيديو وكل ما تحتاجه لتحسين أدائك."
      }
    }
  }
}
</i18n>
